import { useMemo } from 'preact/hooks';
import { formatUpcomingDate } from '@vgtv/time-helpers';
import type { Asset } from '@schibsted-svp/svp-api-types';

import { useTranslation, type i18n } from '../../../utils/useTranslation';
import {
  getDurationInMilliseconds,
  formatShortDuration,
} from '../../../utils/datetime';
import ns from '../translations';

const ONE_HOUR_IN_MILLISECONDS = getDurationInMilliseconds({ hours: 1 });

const isCountdownActive = (timeToStartInMilliseconds: number): boolean => {
  return timeToStartInMilliseconds <= ONE_HOUR_IN_MILLISECONDS - 1;
};

const formatUpcomingLabel = (
  i18n: i18n,
  flightTimesStartInMilliseconds: number,
  streamType: Asset['streamType']
) => {
  if (streamType === 'live') {
    return formatUpcomingDate({
      timestamp: Math.floor(flightTimesStartInMilliseconds / 1000),
      locale: i18n.locale === 'no' ? 'nb' : 'sv',
      streamType,
    });
  }

  return formatUpcomingDate({
    timestamp: Math.floor(flightTimesStartInMilliseconds / 1000),
    locale: i18n.locale === 'no' ? 'nb' : 'sv',
    streamType,
  });
};

export const useUpcomingLabel = (
  flightTimesStartInMilliseconds: number,
  timeToStartInMilliseconds: number,
  streamType: Asset['streamType']
) => {
  const { i18n } = useTranslation(ns);

  return useMemo(() => {
    if (isCountdownActive(timeToStartInMilliseconds)) {
      return {
        isCountdownActive: true,
        label: formatShortDuration(timeToStartInMilliseconds),
      };
    }

    return {
      isCountdownActive: false,
      label: formatUpcomingLabel(
        i18n,
        flightTimesStartInMilliseconds,
        streamType
      ),
    };
  }, [
    flightTimesStartInMilliseconds,
    timeToStartInMilliseconds,
    streamType,
    i18n,
  ]);
};
